// Track if main add-to-cart button was clicked
let mainProductClicked = false;

// Wait for DOM to load before attaching listener
document.addEventListener('DOMContentLoaded', () => {
  const mainButton = document.querySelector('.add-to-cart-single-productpage .button.button--primary');
  if (mainButton) {
    mainButton.addEventListener('click', () => {
      mainProductClicked = true;
      console.log('✅ Main product clicked');
    });
  }
});

if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        console.log(this.querySelector('[type="submit"]'));

        if (document.querySelector('cart-drawer')) {
          this.submitButton.setAttribute('aria-haspopup', 'dialog');
        }

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      getAlternativeVariantId(selectedVariantId) {
        console.log("test 1")
        console.log(selectedVariantId)
        if (!selectedVariantId) return null;

        const mapScript = this.querySelector('[data-variant-alternatives]');
        console.log(this)
        console.log(mapScript)
        if (!mapScript) return null;
        console.log("test 2")
        try {
          this.variantAlternativeMap =
            this.variantAlternativeMap || JSON.parse(mapScript.textContent || '{}');

          console.log("Variants with Alternative", this.variantAlternativeMap)
        } catch (error) {
          console.error('Unable to parse variant alternative map:', error);
          return null;
        }

        const alternativeVariantId = this.variantAlternativeMap[String(selectedVariantId)];
        if (!alternativeVariantId) return null;

        return String(alternativeVariantId);
      }

      getAddOnVariantIds(selectedVariantId) {
        if (!selectedVariantId) return [];

        const mapScript = this.querySelector('[data-variant-addons]');
        if (!mapScript) return [];

        try {
          this.variantAddOnMap = this.variantAddOnMap || JSON.parse(mapScript.textContent || '{}');
        } catch (error) {
          console.error('Unable to parse variant add-ons map:', error);
          return [];
        }

        const addOnValues = this.variantAddOnMap[String(selectedVariantId)];
        if (!Array.isArray(addOnValues)) return [];

        return addOnValues
          .map((value) => (value == null ? null : String(value).trim()))
          .filter((value) => value && value !== 'null' && value !== 'undefined');
      }

      getBundleId() {
        const now = new Date();
        const pad = (value) => String(value).padStart(2, '0');

        return `${now.getFullYear()}${pad(now.getMonth() + 1)}${pad(now.getDate())}${pad(now.getHours())}${pad(
          now.getMinutes()
        )}${pad(now.getSeconds())}-${String(now.getMilliseconds()).padStart(3, '0')}`;
      }

      getLineItemProperties(formData) {
        const properties = {};

        for (const [key, value] of formData.entries()) {
          if (!key.startsWith('properties[') || !key.endsWith(']')) continue;
          const propertyKey = key.slice(11, -1);
          if (!propertyKey) continue;
          properties[propertyKey] = value;
        }

        return properties;
      }

      buildCartPayload(formData) {
        const selectedVariantId = formData.get('id');
        console.log("Getting ID: ", selectedVariantId)
        const alternativeVariantId = this.getAlternativeVariantId(selectedVariantId);
        console.log("Alternative: ", alternativeVariantId)
        const mainVariantId = alternativeVariantId || selectedVariantId;
        const addOnVariantIds = this.getAddOnVariantIds(selectedVariantId);
        const hasBundle = addOnVariantIds.length > 0;
        const bundleId = hasBundle ? this.getBundleId() : null;
        const quantity = parseInt(formData.get('quantity') || '1', 10) || 1;
        const sellingPlan = formData.get('selling_plan');
        const baseProperties = this.getLineItemProperties(formData);
        const mainProperties = { ...baseProperties };

        if (hasBundle) {
          mainProperties._bundleId = bundleId;
          mainProperties._bundleRole = 'main';
        }

        const mainItem = {
          id: mainVariantId,
          quantity,
        };

        if (sellingPlan) {
          mainItem.selling_plan = sellingPlan;
        }

        if (Object.keys(mainProperties).length > 0) {
          mainItem.properties = mainProperties;
        }

        const items = [mainItem];

        if (hasBundle) {
          addOnVariantIds.forEach((addOnVariantId) => {
            items.push({
              id: addOnVariantId,
              quantity,
              properties: {
                _bundleId: bundleId,
                _bundleRole: 'addOn',
              },
            });
          });
        }

        const payload = { items };

        if (this.cart) {
          payload.sections = this.cart.getSectionsToRender().map((section) => section.id);
          payload.sections_url = window.location.pathname;
        }

        return { payload, mainVariantId };
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();

        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();
        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('json');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';

        const formData = new FormData(this.form);
        const { payload, mainVariantId } = this.buildCartPayload(formData);
        if (this.cart) this.cart.setActiveElement(document.activeElement);
        config.body = JSON.stringify(payload);

        try {
          const response = await fetch(`${routes.cart_add_url}`, config).then(res => res.json());

          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {
              source: 'product-form',
              productVariantId: mainVariantId,
              errors: response.errors || response.description,
              message: response.message,
            });

            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (soldOutMessage) {
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
            }

            this.error = true;
            return;
          }

          if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          this.error = false;
          if (!response.key && Array.isArray(response.items) && response.items[0]?.key) {
            response.key = response.items[0].key;
          }

          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener(
              'modalClosed',
              () => {
                setTimeout(() => {
                  this.cart.renderContents(response);
                }, 200);
              },
              { once: true }
            );
            quickAddModal.hide(true);
          } else {
            if (response.sections && typeof response.sections === 'object') {
              this.cart.renderContents(response);
            } else {
              console.warn('⚠️ Unexpected cart response format. Skipping render.');
            }
          }

          if (mainProductClicked) {
            await this.handleUpsellsAndComplements();
            mainProductClicked = false;
          }

        } catch (error) {
          console.error('🛑 Add to cart failed:', error);
          this.handleErrorMessage("There was an issue adding the product. Please try again.");
          this.error = true;
        } finally {
          this.submitButton.classList.remove('loading');
          this.querySelector('.loading__spinner').classList.add('hidden');

          if (!this.error) this.submitButton.removeAttribute('aria-disabled');


          if (this.cart && this.cart.classList.contains('is-empty')) {
            this.cart.classList.remove('is-empty');
          }
        }
      }

      async handleUpsellsAndComplements() {
        // Handle optional upgrade click
        if (window.jQuery && $(".strength-upgrade-wrapper").length && !$(".strength-upgrade-wrapper").hasClass("unchecked")) {
          const upgradeBtn = $(".upgrade-atc");
          if (upgradeBtn.length) {
            upgradeBtn.click();
            console.log("✅ Upgrade added");
            await new Promise(resolve => setTimeout(resolve, 800));
          }
        }

        // Handle complementary products
        const complementaryButtons = document.querySelectorAll(
          '[class^="complementary-prod"] .card--horizontal__quick-add'
        );
        for (let i = 0; i < complementaryButtons.length; i++) {
          const btn = complementaryButtons[i];
          if (btn) {
            btn.click();
            console.log(`✅ Complementary product ${i + 1} clicked`);
            await new Promise(resolve => setTimeout(resolve, 800));
          }
        }
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;

        this.errorMessage =
          this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
